import {Component, OnInit} from '@angular/core';
import {StepsService} from "../../services/steps.service";
import {ChoiceService} from "../../services/choice.service";
import {Choice} from "../../models/choice.enum";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.scss']
})
export class Step1Component implements OnInit {
  imgUrl = environment.serverImages

  public get Choice(): typeof Choice {
    return Choice;
  }

  public get userChoice() {
    return this.choiceSrv.choice;
  }

  constructor(private stepSrv: StepsService, private choiceSrv: ChoiceService){
  }

  ngOnInit(): void {

  }


  select(choice: string) {
    this.choiceSrv.setChoice(choice);
    this.stepSrv.nextStep();


  }

  jumpTpStep3() {
    this.choiceSrv.setChoice(this.Choice.none);
    this.stepSrv.setStep(3);
  }

}
